<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t('content.amnaudittitle') }}</h5>
            <p class="text-sm text-secondary mb-0">{{ $t('content.amnauditsubtitle') }}</p>
          </div>
          <div class="card-body pt-0">
          <!-- แถวปุ่ม Radio ผูกค่า true / false เข้ากับตัวแปร random ของ Vue 3 -->
          <div class="row mt-2 mb-2">
            <div class="col-lg-12">
              <div class="d-flex align-items-center flex-wrap" style="gap: 24px; padding-left: 0;">
                
                <!-- Radio ตัวที่ 1 (สุ่มตรวจภายใน -> random = true) -->
                <div class="d-flex align-items-center" style="margin: 0; padding: 0; min-height: auto;">
                  <!-- ใส่ :value="true" เพื่อส่งค่าเป็น Boolean true -->
                  <input type="radio" 
                        v-model="random"
                        name="inspectionType" 
                        id="internalCheck" 
                        :value="true" 
                        :style="{
                          margin: '0 8px 0 0',
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                          appearance: 'none',
                          '-webkit-appearance': 'none',
                          borderRadius: '50%',
                          outline: 'none',
                          border: random === true ? '2px solid #1a7f37' : '2px solid #adb5bd',
                          backgroundColor: '#ffffff',
                          backgroundImage: random === true ? 'radial-gradient(circle, #1a7f37 45%, #ffffff 50%)' : 'none'
                        }">
                  <label class="text-sm font-weight-bold mb-0" for="internalCheck" 
                        style="color: #344767; cursor: pointer; user-select: none; line-height: 1; margin: 0;">
                    ใช้สำหรับสุ่มตรวจภายใน
                  </label>
                </div>

                <!-- Radio ตัวที่ 2 (ธนาคารตรวจ -> random = false) -->
                <div class="d-flex align-items-center" style="margin: 0; padding: 0; min-height: auto;">
                  <!-- ใส่ :value="false" เพื่อส่งค่าเป็น Boolean false -->
                  <input type="radio" 
                        v-model="random"
                        name="inspectionType" 
                        id="bankCheck" 
                        :value="false" 
                        :style="{
                          margin: '0 8px 0 0',
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                          appearance: 'none',
                          '-webkit-appearance': 'none',
                          borderRadius: '50%',
                          outline: 'none',
                          border: random === false ? '2px solid #1a7f37' : '2px solid #adb5bd',
                          backgroundColor: '#ffffff',
                          backgroundImage: random === false ? 'radial-gradient(circle, #1a7f37 45%, #ffffff 50%)' : 'none'
                        }">
                  <label class="text-sm font-weight-bold mb-0" for="bankCheck" 
                        style="color: #344767; cursor: pointer; user-select: none; line-height: 1; margin: 0;">
                    ใช้สำหรับธนาคารตรวจ
                  </label>
                </div>

              </div>
            </div>
          </div>


          <pre></pre>

            <!-- Input panel -->
            <div class="row mt-3">
              <div class="col-lg-4 col-md-6">
                <div class="d-flex flex-column gap-1">
                  <span class="text-sm font-weight-bold" style="color:#344767">{{ $t('content.amnauditoverallpct') }}</span>
                  <div class="as-numinput">
                    <input type="number" :value="overallPct" @input="setOverallPct($event)" min="0" max="100" step="0.1" class="as-ni-input" />
                    <span class="as-ni-suffix">%</span>
                  </div>
                  <p class="text-xs text-secondary mb-0">{{ $t('content.amnauditoverallhelper', { val: fmtMoney(targetTotalValue), total: fmtMoney(totalValue) }) }}</p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="d-flex flex-column gap-1">
                  <span class="text-sm font-weight-bold" style="color:#344767">{{ $t('content.amnaudittargetcount') }}</span>
                  <div class="as-numinput">
                    <input type="number" :value="targetCount" @input="setTargetCount($event)" min="0" :max="totalCount" step="1" class="as-ni-input as-ni-input-wide" />
                    <span class="as-ni-suffix">{{ $t('content.amnauditunititem') }}</span>
                  </div>
                  <p class="text-xs text-secondary mb-0">{{ $t('content.amnaudittargetcounthelper', { total: fmtInt(totalCount) }) }}</p>
                </div>
              </div>

              <div class="col-lg-4 col-md-12 mt-2 mt-lg-0">
                <label class="form-label ms-0 text-sm font-weight-bold">{{ $t('content.amnauditgoldlabel') }}</label>
                <div class="as-split-row">
                  <div class="as-split-item">
                    <span class="as-split-lbl as-lbl-gold">{{ $t('content.amnaudithasgold') }}</span>
                    <div class="as-numinput">
                      <input type="number" :value="goldPct" @input="setGoldPct($event)" min="0" max="100" step="1" class="as-ni-input" />
                      <span class="as-ni-suffix">%</span>
                    </div>
                  </div>
                  <span class="as-split-sep">/</span>
                  <div class="as-split-item">
                    <span class="as-split-lbl as-lbl-blue">{{ $t('content.amnauditnogold') }}</span>
                    <div class="as-numinput">
                      <input type="number" :value="nonGoldPct" @input="setNonGoldPct($event)" min="0" max="100" step="1" class="as-ni-input" />
                      <span class="as-ni-suffix">%</span>
                    </div>
                  </div>
                  <span class="as-badge" :class="sumTypePct === 100 ? 'as-badge-ok' : 'as-badge-warn'">{{ $t('content.amnauditbadgetotal', { sum: sumTypePct }) }}</span>
                </div>
                <div class="as-type-bar mt-2">
                  <div class="as-type-bar-gold" :style="{ width: Math.min(100, Math.max(0, goldPct)) + '%' }"></div>
                  <div class="as-type-bar-blue" :style="{ width: Math.min(100, Math.max(0, nonGoldPct)) + '%' }"></div>
                </div>
              </div>
            </div>

            <hr />

            <!-- KPI strip -->
            <div class="row mt-3">
              <div class="col-lg-3 col-md-6 mb-3">
                <div class="as-kpi as-kpi-teal">
                  <div class="as-kpi-lbl">{{ $t('content.amnauditkpitotal') }}</div>
                  <div class="as-kpi-val">{{ fmtMoney(totalValue) }}<span class="as-kpi-cur"> ฿</span></div>
                  <div class="as-kpi-sub">{{ $t('content.amnauditkpisubcount', { count: fmtInt(totalCount), months: MONTHS.length }) }}</div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3">
                <div class="as-kpi as-kpi-blue">
                  <div class="as-kpi-lbl">{{ $t('content.amnauditkpitarget') }}</div>
                  <div class="as-kpi-val">{{ fmtMoney(targetTotalValue) }}<span class="as-kpi-cur"> ฿</span></div>
                  <div class="as-kpi-sub">{{ $t('content.amnauditkpisubpct', { pct: overallPct }) }}</div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3">
                <div class="as-kpi as-kpi-gold">
                  <div class="as-kpi-lbl">{{ $t('content.amnauditkpigold') }}</div>
                  <div class="as-kpi-val as-kpi-gold-text">{{ fmtMoney(totalGoldValue) }}<span class="as-kpi-cur"> ฿</span></div>
                  <div class="as-kpi-sub">{{ $t('content.amnauditkpisubgold', { pct: goldPct }) }}</div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3">
                <div class="as-kpi as-kpi-blue2">
                  <div class="as-kpi-lbl">{{ $t('content.amnauditkpinongold') }}</div>
                  <div class="as-kpi-val as-kpi-blue-text">{{ fmtMoney(totalNonGoldValue) }}<span class="as-kpi-cur"> ฿</span></div>
                  <div class="as-kpi-sub">{{ $t('content.amnauditkpisubgold', { pct: nonGoldPct }) }}</div>
                </div>
              </div>
            </div>

            <!-- Validation banner -->
            <div v-if="hasWarnings" class="as-banner mt-2 mb-3">
              <i class="material-icons material-symbols-outlined" style="font-size:16px;margin-right:6px;flex-shrink:0">warning</i>
              <strong>{{ $t('content.amnauditwarnlabel') }}</strong>
              <template v-if="!monthSumOk">
                <span class="as-banner-sep"> · </span>
                <span>{{ $t('content.amnauditwarnmonthpct', { sum: sumMonthPct }) }}</span>
              </template>
              <template v-if="anyOverflow">
                <span class="as-banner-sep"> · </span>
                <span>{{ $t('content.amnauditwarnoverflow') }}</span>
              </template>
              <template v-if="totalOverflow">
                <span class="as-banner-sep"> · </span>
                <span>{{ $t('content.amnauditwarnoverflowttl') }}</span>
              </template>
              <template v-if="sumTypePct !== 100">
                <span class="as-banner-sep"> · </span>
                <span>{{ $t('content.amnauditwarntypepct', { sum: sumTypePct }) }}</span>
              </template>
            </div>

            <!-- Table -->
            <div class="as-table-head mt-2">
              <h6 class="mb-0">{{ $t('content.amnaudittabledetail') }}</h6>
              <button class="as-help-btn" @click="showHelp = true" title="วิธีการใช้งาน">
                <i class="material-icons" style="font-size:18px">help_outline</i>
              </button>
            </div>

            <!-- Help modal -->
            <teleport to="body">
              <div v-if="showHelp" class="as-modal-backdrop" @click.self="showHelp = false">
                <div class="as-modal">
                  <div class="as-modal-header">
                    <span>วิธีการใช้งานและการคำนวณ</span>
                    <button class="as-modal-close" @click="showHelp = false">
                      <i class="material-icons" style="font-size:20px">close</i>
                    </button>
                  </div>
                  <div class="as-modal-body">

                    <div class="as-help-section">
                      <div class="as-help-section-title">
                        <i class="material-icons" style="font-size:16px;color:#1a73e8">touch_app</i>
                        วิธีการใช้งาน
                      </div>
                      <ol class="as-help-list">
                        <li>กรอก <strong>% มูลค่าที่ต้องการสุ่ม</strong> — ระบุว่าต้องการตรวจสอบมูลค่ากี่เปอร์เซ็นต์ของยอดคงเหลือทั้งหมด</li>
                        <li>กรอก <strong>จำนวนรายการขั้นต่ำที่ต้องการ</strong> — จำนวนตั๋วที่ต้องการสุ่มตรวจขั้นต่ำ</li>
                        <li>กรอก <strong>% มีทอง / ไม่มีทอง</strong> — สัดส่วนระหว่างตั๋วที่มีทองและไม่มีทอง ต้องรวมกันได้ 100%</li>
                        <li>กรอก <strong>% การกระจายรายเดือน</strong> — ระบุว่าต้องการกระจายการสุ่มในแต่ละเดือนเป็นสัดส่วนเท่าไร ต้องรวมกันได้ 100% หรือมากกว่า</li>
                        <li>เมื่อข้อมูลครบถ้วนและไม่มี warning กด <strong>Export to Excel</strong> เพื่อดาวน์โหลดผลลัพธ์</li>
                      </ol>
                    </div>

                    <div class="as-help-section">
                      <div class="as-help-section-title">
                        <i class="material-icons" style="font-size:16px;color:#b7872f">calculate</i>
                        วิธีการคำนวณ
                      </div>
                      <div class="as-help-formula-list">
                        <div class="as-help-formula">
                          <div class="as-help-formula-label">มูลค่าของการสุ่ม</div>
                          <div class="as-help-formula-expr">= มูลค่าคงเหลือทั้งหมด × % มูลค่าที่ต้องการสุ่ม</div>
                        </div>
                        <div class="as-help-formula">
                          <div class="as-help-formula-label">ยอดสุ่ม / เดือน</div>
                          <div class="as-help-formula-expr">= มูลค่าของการสุ่ม × % การกระจายของเดือนนั้น</div>
                        </div>
                        <div class="as-help-formula">
                          <div class="as-help-formula-label">มูลค่าตั๋วที่มีทอง / เดือน</div>
                          <div class="as-help-formula-expr">= ยอดสุ่ม / เดือน × % มีทอง</div>
                        </div>
                        <div class="as-help-formula">
                          <div class="as-help-formula-label">มูลค่าตั๋วที่ไม่มีทอง / เดือน</div>
                          <div class="as-help-formula-expr">= ยอดสุ่ม / เดือน × % ไม่มีทอง</div>
                        </div>
                      </div>
                    </div>

                    <div class="as-help-section">
                      <div class="as-help-section-title">
                        <i class="material-icons" style="font-size:16px;color:#f57f17">warning</i>
                        เงื่อนไข Warning
                      </div>
                      <ul class="as-help-list">
                        <li>% การกระจายรายเดือนรวมกันต้อง <strong>ไม่ต่ำกว่า 100%</strong></li>
                        <li>% มีทอง + % ไม่มีทอง ต้องรวมกันได้ <strong>พอดี 100%</strong></li>
                        <li>ยอดสุ่มในแต่ละเดือนต้อง <strong>ไม่เกินมูลค่าคงเหลือของเดือนนั้น</strong></li>
                        <li>ยอดสุ่มรวมต้อง <strong>ไม่เกินยอดคงเหลือทั้งหมด</strong></li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </teleport>
            <div class="table-responsive mt-2">
              <table class="table table-flush as-table">
                <thead class="thead-light">
                  <tr>
                    <th class="as-th-first">{{ $t('content.amnauditthitem') }}</th>
                    <th v-for="(m, i) in MONTHS" :key="i" class="text-center">{{ m.th }}</th>
                    <th class="as-th-total text-center">{{ $t('content.amnaudiththtotal') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrowcount') }}</td>
                    <td v-for="(m, i) in MONTHS" :key="i" class="text-sm text-center text-secondary">{{ fmtInt(m.count) }}</td>
                    <td class="text-sm text-center font-weight-bold as-td-total-col">{{ fmtInt(totalCount) }}</td>
                  </tr>
                  <tr>
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrowvalue') }}</td>
                    <td v-for="(m, i) in MONTHS" :key="i" class="text-sm text-center text-secondary">{{ fmtMoney(m.value) }}</td>
                    <td class="text-sm text-center font-weight-bold as-td-total-col">{{ fmtMoney(totalValue) }}</td>
                  </tr>
                  <tr class="as-row-pct">
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrowpct') }}</td>
                    <td v-for="(_, i) in MONTHS" :key="i" class="as-td-inp">
                      <div class="as-numinput as-numinput-sm">
                        <input
                          type="number"
                          :value="monthPct[i]"
                          @input="updateMonthPct(i, $event)"
                          min="0"
                          max="100"
                          step="1"
                          class="as-ni-input"
                        />
                        <span class="as-ni-suffix">%</span>
                      </div>
                    </td>
                    <td class="as-td-total-col text-center">
                      <span class="as-badge" :class="sumMonthPct >= 100 ? 'as-badge-ok' : 'as-badge-err'">{{ $t('content.amnauditbadgetotal', { sum: sumMonthPct }) }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrowsample') }}</td>
                    <td
                      v-for="(v, i) in monthValueArr"
                      :key="i"
                      class="text-sm text-center font-weight-bold as-td-month-val"
                      :class="overflowsArr[i] ? 'as-td-overflow' : ''"
                    >{{ fmtMoney(v) }}</td>
                    <td class="text-sm text-center font-weight-bold as-td-month-val as-td-total-col">{{ fmtMoney(sumMonthValue) }}</td>
                  </tr>
                  <tr>
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrowgold') }}</td>
                    <td v-for="(v, i) in goldArr" :key="i" class="text-sm text-center font-weight-bold as-td-gold-row">{{ fmtMoney(v) }}</td>
                    <td class="text-sm text-center font-weight-bold as-td-gold-row as-td-total-col">{{ fmtMoney(totalGoldValue) }}</td>
                  </tr>
                  <tr>
                    <td class="as-td-first text-sm">{{ $t('content.amnauditrownongold') }}</td>
                    <td v-for="(v, i) in nonGoldArr" :key="i" class="text-sm text-center font-weight-bold as-td-nongold-row">{{ fmtMoney(v) }}</td>
                    <td class="text-sm text-center font-weight-bold as-td-nongold-row as-td-total-col">{{ fmtMoney(totalNonGoldValue) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Footer actions -->
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-end align-items-center gap-2">
                <material-button color="danger" class="mb-3" @click="reset">
                  <i class="material-icons material-symbols-outlined">restart_alt</i>
                  {{ $t('content.amnauditbtnreset') }}
                </material-button>
                <material-button color="success" class="mb-3" @click="XlsxGen" :disabled="!canExport">
                  <i class="material-icons material-symbols-outlined">download</i>
                  Export to Excel
                </material-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import MaterialButton from '@/components/MaterialButton.vue'
import moment from 'moment'
import axios from "axios";
import * as st from "@/config/setting.js";
import ProgressSpinner from 'primevue/progressspinner';

import { useStockMovementStore } from '@/stores/stockmovement';
const storest = useStockMovementStore()

const { t } = useI18n()
const swal = inject("$swal");

const apiData = ref({});
const loading = ref(false);
const key = JSON.parse(localStorage.getItem("shop_seleted"));
const showHelp = ref(false)
const random = ref(true)

// Calculate 7 dynamic months for columns
const dynamicMonths = computed(() => {
  const months = [];
  const now = new Date();
  for (let i = 6; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = `${d.toLocaleString('th-TH', { month: 'short' })}-${d.getFullYear().toString().slice(-2)}`;
    const monthVal = d.getMonth() + 1;
    const value = `${d.getFullYear()}${monthVal.toString().padStart(2, '0')}`;
    months.push({ Label: label, Value: value });
  }
  return months;
});

const MONTHS = computed(() => {
  return dynamicMonths.value.map(m => ({
    th: m.Label,
    count: apiData.value?.[m.Value]?.remaining || 0,
    value: apiData.value?.[m.Value]?.remainValue || 0
  }));
});
const DEFAULTS = {
  overallPct:  0,
  targetCount: 0,
  goldPct:     0,
  nonGoldPct:  0,
  monthPct:    [0, 0, 0, 0, 0, 0, 0],
}

const overallPct  = ref(DEFAULTS.overallPct)
const targetCount = ref(DEFAULTS.targetCount)
const goldPct     = ref(DEFAULTS.goldPct)
const nonGoldPct  = ref(DEFAULTS.nonGoldPct)
const monthPct    = ref([...DEFAULTS.monthPct])

const updateMonthPct = (idx, e) => {
  const n   = e.target.value === '' ? 0 : Math.min(100, Math.max(0, Number(e.target.value)))
  const arr = [...monthPct.value]
  arr[idx]  = n
  monthPct.value = arr
  e.target.value = n
}

const setOverallPct = (e) => {
  const n = e.target.value === '' ? 0 : Math.min(100, Math.max(0, Number(e.target.value)))
  overallPct.value = n
  e.target.value = n
}

const setTargetCount = (e) => {
  const n = e.target.value === '' ? 0 : Math.min(totalCount.value, Math.max(0, Math.round(Number(e.target.value))))
  targetCount.value = n
  e.target.value = n
}

const setGoldPct = (e) => {
  const n = e.target.value === '' ? 0 : Math.min(100, Math.max(0, Number(e.target.value)))
  goldPct.value    = n
  nonGoldPct.value = 100 - n
  e.target.value = n
}
const setNonGoldPct = (e) => {
  const n = e.target.value === '' ? 0 : Math.min(100, Math.max(0, Number(e.target.value)))
  nonGoldPct.value = n
  goldPct.value    = 100 - n
  e.target.value = n
}

const reset = () => {
  overallPct.value  = DEFAULTS.overallPct
  targetCount.value = DEFAULTS.targetCount
  goldPct.value     = DEFAULTS.goldPct
  nonGoldPct.value  = DEFAULTS.nonGoldPct
  monthPct.value = [...DEFAULTS.monthPct]
  random.value = true
}


// ── Derived totals from MONTHS ─────────────────────────────────────────────
const totalCount = computed(() => MONTHS.value.reduce((s, m) => s + m.count, 0))
const totalValue = computed(() => MONTHS.value.reduce((s, m) => s + m.value, 0))

// ── Computed sampling values ───────────────────────────────────────────────
const targetTotalValue = computed(() => totalValue.value * (overallPct.value / 100))

const monthValueArr = computed(() =>
  MONTHS.value.map((_, i) => targetTotalValue.value * (monthPct.value[i] / 100))
)

const goldArr    = computed(() => monthValueArr.value.map(v => v * (goldPct.value    / 100)))
const nonGoldArr = computed(() => monthValueArr.value.map(v => v * (nonGoldPct.value / 100)))

const sumMonthPct       = computed(() => monthPct.value.reduce((s, x) => s + x, 0))
const sumTypePct        = computed(() => goldPct.value + nonGoldPct.value)
const sumMonthValue     = computed(() => monthValueArr.value.reduce((s, x) => s + x, 0))
const totalGoldValue    = computed(() => goldArr.value.reduce((s, x) => s + x, 0))
const totalNonGoldValue = computed(() => nonGoldArr.value.reduce((s, x) => s + x, 0))

// ── Overflow detection ─────────────────────────────────────────────────────
const overflowsArr  = computed(() => MONTHS.value.map((m, i) => monthValueArr.value[i] > m.value))
const anyOverflow   = computed(() => overflowsArr.value.some(Boolean))
const totalOverflow = computed(() => sumMonthValue.value > totalValue.value)

// ── Validation ─────────────────────────────────────────────────────────────
const monthSumOk  = computed(() => sumMonthPct.value >= 100)
const hasWarnings = computed(() =>
  !monthSumOk.value || anyOverflow.value || totalOverflow.value || sumTypePct.value !== 100
)

const canExport = computed(() =>
  overallPct.value > 0 &&
  targetCount.value > 0 &&
  goldPct.value > 0 &&
  nonGoldPct.value > 0 &&
  monthPct.value.reduce((s, x) => s + x, 0) >= 1 &&
  !anyOverflow.value
)

const fmtMoney = (n) => {
  if (!isFinite(n)) return '–'
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
const fmtInt = (n) => {
  if (!isFinite(n)) return '–'
  return Math.round(n).toLocaleString('en-US')
}

const loadDataReportApi = async () => {
  apiData.value = {}
  let data = "";

  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storest.txSummaryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
            if (response.data && response.data.data) {
              apiData.value = response.data.data;
            } 
      }
    }
  }
}

loadDataReportApi()

async function XlsxGen(item) {
  loading.value = true
  const monthsPayload = goldArr.value.map((goldVal, index) => ({
    goldMinValue: Number(Number(goldVal).toFixed(2)),
    otherMinValue: Number(Number(nonGoldArr.value[index]).toFixed(2))
  })).reverse();

  let data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    months: monthsPayload,
    minTicket: targetCount.value,
    goldCatUids: [
        "632499577103715035",
        "632499579599326361",
        "632499583399367439",
        "632499582875079190",
        "632499582501785943",
        "632499582636003747"
    ],
    otherCatUids: [
        "632499585429411671",
        "632499585202919135"
    ],
    random: random.value
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
     method: 'POST',
     data: data,
     url: st.url_api + `/pawn-rpt-svc/bank/check/xlsx`,
     headers: { Authorization: `Bearer ${accessToken}` },
     responseType: 'arraybuffer',
   });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('blob - response ', response);
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = `rpAuditSampling_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}

</script>

<style scoped>

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* NumInput */
.as-numinput {
  display: inline-flex;
  align-items: center;
  border: 1.5px solid #344767;
  border-radius: 8px;
  height: 36px;
  padding: 0 10px;
  background: #f8f9fa;
  width: fit-content;
}
.as-numinput:focus-within {
  border-color: #7928ca;
  box-shadow: 0 0 0 2px rgba(121, 40, 202, 0.15);
}
.as-numinput-sm { height: 30px; padding: 0 8px; }
.as-ni-input {
  border: none; outline: none; background: transparent;
  font-family: 'ui-monospace', 'Menlo', 'Consolas', monospace;
  font-size: 15px; font-weight: 600;
  color: #344767;
  text-align: right;
  width: 72px;
  -moz-appearance: textfield;
  appearance: textfield;
}
.as-ni-input::-webkit-outer-spin-button,
.as-ni-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.as-ni-input-wide     { width: 100px; }
.as-numinput-sm .as-ni-input { width: 50px; font-size: 13px; }
.as-ni-suffix {
  font-size: 12px; font-weight: 500;
  color: #7b809a;
  margin-left: 6px;
  white-space: nowrap;
}

/* Gold/Non-gold split */
.as-split-row  { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.as-split-item { display: flex; align-items: center; gap: 6px; }
.as-split-lbl  { font-size: 12px; font-weight: 600; }
.as-lbl-gold   { color: #b7872f; }
.as-lbl-blue   { color: #2b5d99; }
.as-split-sep  { color: #aaa; font-size: 14px; }
.as-type-bar {
  height: 8px; border-radius: 999px;
  background: #e9ecef;
  display: flex; overflow: hidden;
}
.as-type-bar-gold { background: #b7872f; transition: width .2s; }
.as-type-bar-blue { background: #2b5d99; transition: width .2s; }

/* Badge */
.as-badge {
  display: inline-flex; align-items: center;
  padding: 2px 8px; border-radius: 6px;
  font-size: 11px; font-weight: 600; line-height: 1.6;
  white-space: nowrap;
}
.as-badge-ok   { background: #e8f5e9; color: #388e3c; border: 1px solid #c8e6c9; }
.as-badge-warn { background: #fff8e1; color: #f57f17; border: 1px solid #ffe082; }
.as-badge-err  { background: #ffebee; color: #c62828; border: 1px solid #ffcdd2; }

/* KPI cards */
.as-kpi {
  border-radius: 10px;
  padding: 14px 16px;
  border-top: 3px solid #344767;
  background: #fff;
  box-shadow: 0 2px 12px rgba(52,71,103,.08);
  height: 100%;
}
.as-kpi-teal  { border-top-color: #1a73e8; }
.as-kpi-blue  { border-top-color: #344767; }
.as-kpi-gold  { border-top-color: #b7872f; }
.as-kpi-blue2 { border-top-color: #2b5d99; }
.as-kpi-lbl  { font-size: 13px; font-weight: 600; color: #7b809a; }
.as-kpi-val  {
  font-family: 'ui-monospace','Menlo','Consolas',monospace;
  font-size: 22px; font-weight: 700;
  color: #344767; line-height: 1.2;
  font-variant-numeric: tabular-nums;
  margin: 4px 0 3px;
  word-break: break-all;
}
.as-kpi-gold-text { color: #6b4f12; }
.as-kpi-blue-text { color: #2b5d99; }
.as-kpi-cur  { font-size: 12px; color: #aaa; font-weight: 400; font-family: inherit; }
.as-kpi-sub  { font-size: 11px; color: #7b809a; }

/* Validation banner */
.as-banner {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px; color: #f57f17;
  display: flex; align-items: center; flex-wrap: wrap; gap: 0 4px;
}
.as-banner strong { color: #f57f17; }
.as-banner-sep    { color: #ffe082; }

/* Table header helpers */
.as-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

/* Help button */
.as-help-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border-radius: 50%;
  border: 1px solid #d0d5dd;
  background: #fff; color: #7b809a;
  cursor: pointer; transition: all .15s;
  flex-shrink: 0;
}
.as-help-btn:hover { background: #f0f4ff; color: #344767; border-color: #344767; }

/* Modal */
.as-modal-backdrop {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(20, 30, 50, 0.45);
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
}
.as-modal {
  background: #fff; border-radius: 14px;
  width: 100%; max-width: 560px;
  max-height: 80vh; display: flex; flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.2);
  overflow: hidden;
}
.as-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  font-size: 15px; font-weight: 700; color: #344767;
  flex-shrink: 0;
}
.as-modal-close {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; border-radius: 50%;
  border: none; background: transparent; color: #7b809a;
  cursor: pointer; transition: background .15s;
}
.as-modal-close:hover { background: #f0f4ff; color: #344767; }
.as-modal-body {
  overflow-y: auto; padding: 20px;
  display: flex; flex-direction: column; gap: 20px;
}

/* Help sections */
.as-help-section { display: flex; flex-direction: column; gap: 10px; }
.as-help-section-title {
  display: flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 700; color: #344767;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f0f0;
}
.as-help-list {
  margin: 0; padding-left: 18px;
  display: flex; flex-direction: column; gap: 6px;
  font-size: 13px; color: #4a5163; line-height: 1.6;
}
.as-help-formula-list { display: flex; flex-direction: column; gap: 8px; }
.as-help-formula {
  background: #f8f9fa; border-radius: 8px;
  padding: 10px 14px;
  display: flex; flex-direction: column; gap: 3px;
}
.as-help-formula-label {
  font-size: 12px; font-weight: 700; color: #344767;
}
.as-help-formula-expr {
  font-size: 13px; color: #4a5163;
  font-family: 'ui-monospace','Menlo','Consolas',monospace;
}

/* Table cell overrides */
.as-table .as-th-first { text-align: left; min-width: 160px; }
.as-table .as-th-total { min-width: 130px; background: #a08060; color: #fff !important; }
.as-td-first { text-align: left; font-weight: 600; color: #344767; white-space: nowrap; }
.as-row-pct  { background: #fbf9f2; }
.as-td-inp   { background: #fbf9f2; padding: 6px 12px; vertical-align: middle; text-align: center; }
.as-td-month-val { background: #f4f1e7; }
.as-td-overflow  { background: #ffebee !important; color: #c62828 !important; }
.as-td-gold-row  { background: #fbf3df; color: #6b4f12; }
.as-td-nongold-row { background: #eaf2fb; color: #2b5d99; }
.as-td-total-col { background: #f0ece0; font-weight: 700; }

.gap-2 { gap: 0.5rem; }
</style>
